var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifyTicked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37988 12L10.7899 14.42L15.6199 9.57996",
    stroke: "#545F71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7499 2.44995C11.4399 1.85995 12.5699 1.85995 13.2699 2.44995L14.8499 3.80995C15.1499 4.06995 15.7099 4.27995 16.1099 4.27995H17.8099C18.8699 4.27995 19.7399 5.14995 19.7399 6.20995V7.90995C19.7399 8.29995 19.9499 8.86995 20.2099 9.16995L21.5699 10.7499C22.1599 11.4399 22.1599 12.5699 21.5699 13.2699L20.2099 14.8499C19.9499 15.1499 19.7399 15.7099 19.7399 16.1099V17.8099C19.7399 18.8699 18.8699 19.7399 17.8099 19.7399H16.1099C15.7199 19.7399 15.1499 19.9499 14.8499 20.2099L13.2699 21.5699C12.5799 22.1599 11.4499 22.1599 10.7499 21.5699L9.16988 20.2099C8.86988 19.9499 8.30988 19.7399 7.90988 19.7399H6.17988C5.11988 19.7399 4.24988 18.8699 4.24988 17.8099V16.0999C4.24988 15.7099 4.03988 15.1499 3.78988 14.8499L2.43988 13.2599C1.85988 12.5699 1.85988 11.4499 2.43988 10.7599L3.78988 9.16995C4.03988 8.86995 4.24988 8.30995 4.24988 7.91995V6.19995C4.24988 5.13995 5.11988 4.26995 6.17988 4.26995H7.90988C8.29988 4.26995 8.86988 4.05995 9.16988 3.79995L10.7499 2.44995Z",
    stroke: "#545F71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyTicked);
export default __webpack_public_path__ + "static/media/verify_ticked.62f33fbdd1fd162e4bef004d16a7ba27.svg";
export { ForwardRef as ReactComponent };